// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useInstruments } from '@hooks/other/useInstruments';
import { useCallback } from 'react';
import { InstrumentId } from '@daml.js/splice-api-token-holding/lib/Splice/Api/Token/HoldingV1';
import { PricingData } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/MarketData/module';
import { DamlMap } from '../../../../utils/DamlMap';
import { MarketData as FormMarketData } from './useMarketData';

export const useConvertToMarketData = () => {
  const { getInstrumentByKey } = useInstruments();

  return useCallback(
    (formMarketData: FormMarketData, asOf: string): DamlMap<InstrumentId, PricingData> => {
      const resultMarketData = new DamlMap<InstrumentId, PricingData>();

      formMarketData.forEach((pricingData) => {
        const instrument = pricingData.instrument && getInstrumentByKey(pricingData.instrument);

        if (!instrument) {
          console.error(
            `Skipping instrument key: "${pricingData.instrument}". Reason: Instrument not found!`,
          );
          return;
        }

        resultMarketData.set(
          { id: instrument.id, admin: instrument.admin },
          {
            tag: pricingData.tag,
            value: pricingData.value,
            asOf,
          },
        );
      });

      return resultMarketData;
    },
    [getInstrumentByKey],
  );
};
